import { useTranslation, Trans } from "react-i18next";

import main from '../../img/Home/main.png';
import el1 from '../../img/Home/el1.png';
import el2 from '../../img/Home/el2.png';
import btc from '../../img/Home/btc.png';
import coin2 from '../../img/Home/coin2.png';

import { Fade } from 'react-awesome-reveal';

import Button from "../Button";

function Main () {

    const { t } = useTranslation();
 
    return(
        <div className="relative pt-[40px] xl:pt-[80px]">
            <div className="max-w-[1220px] relative xl:mx-auto mx-[20px] xl:h-[650px]">
                <div className="flex flex-col md:flex-row justify-between">
                    <div className="flex flex-col items-start">
                        <p className="zen-dots leading-[1.2] text-[32px] xl:text-[64px] text-white">{t('main.1')}</p>
                        <p className="zen-dots leading-[1.2] text-[24px] xl:text-[48px] text-white"><Trans>{t('main.2')}</Trans></p>
                        <p className="xl:max-w-[443px] text-[#FFFFFFB2] text-[14px] ibm-plex mt-[20px] xl:mt-[40px]">{t('main.3')}</p>
                        <Button className="mt-[40px] xl:mt-[60px]"/>
                    </div>
                    <div className="mt-[30px] xl:mt-0 relative xl:static">
                        <img src={btc} className="absolute top-[100px] left-[-20px] w-[150px] sm:w-auto homemaintransition3 xl:hidden block" alt="" /> 
                        <img src={btc} className="absolute right-[450px] top-[280px] homemaintransition3 hidden xl:block" alt="" /> 
                        <Fade triggerOnce='true'><img src={main} className="xl:absolute right-0 z-20 relative pl-[50px] mx-auto" alt="" /></Fade>
                        <img src={el1} className="absolute right-0 top-[-80px] z-10 homemaintransition" alt="" />     
                        <img src={coin2} className="absolute right-0 bottom-0 z-10 hidden xl:block" alt="" />         
                    </div>
                </div>
            </div>
            <img src={el2} className="absolute right-0 top-0 z-10 homemaintransition2 hidden xl:block" alt="" />
            <div className="grid grid-cols-2 md:flex md:h-[60px] xl:h-[120px] max-w-[1220px] relative z-20 mx-[20px] xl:mx-auto mt-[90px] xl:mt-0 gap-y-[20px]">
                <div className="flex-grow xl:w-[244px] md:border-t md:border-b md:border-l border-[#47475E] flex flex-col justify-center items-start xl:items-center">
                    <p className="text-[16px] xl:text-[24px] text-[#FFFFFF] zen-dots">1-2%</p>
                    <p className="ibm-plex text-[#FFFFFFB2] xl:text-[14px] text-[11px]">{t('main.5')}</p>
                </div>
                <div className="flex-grow xl:w-[244px] md:border-t md:border-b md:border-l border-[#47475E] flex flex-col justify-center items-start xl:items-center">
                    <p className="text-[16px] xl:text-[24px] text-[#FFFFFF] zen-dots">30 ms</p>
                    <p className="ibm-plex text-[#FFFFFFB2] xl:text-[14px] text-[11px]">{t('main.6')}</p>
                </div>
                <div className="flex-grow xl:w-[244px] md:border-t md:border-b md:border-l border-[#47475E] flex flex-col justify-center items-start xl:items-center">
                    <p className="text-[16px] xl:text-[24px] text-[#FFFFFF] zen-dots">$250</p>
                    <p className="ibm-plex text-[#FFFFFFB2] xl:text-[14px] text-[11px] ">{t('main.7')}</p>
                </div>
                <div className="flex-grow xl:w-[244px] md:border-t md:border-b md:border-l border-[#47475E] flex flex-col justify-center items-start xl:items-center">
                    <p className="text-[16px] xl:text-[24px] text-[#FFFFFF] zen-dots">{t('main.8')}</p>
                    <p className="ibm-plex text-[#FFFFFFB2] xl:text-[14px] text-[11px]">{t('main.9')}</p>
                </div>
                <div className="flex-grow xl:w-[244px] md:border border-[#47475E] flex flex-col justify-center items-start xl:items-center">
                    <p className="text-[16px] xl:text-[24px] text-[#FFFFFF] zen-dots">1:500</p>
                    <p className="ibm-plex text-[#FFFFFFB2] xl:text-[14px] text-[11px]">{t('main.10')}</p>
                </div>
            </div>
        </div>
    );
}

export default Main;